import { render, staticRenderFns } from "./xlDetialsPage.vue?vue&type=template&id=77cff94a&scoped=true"
import script from "./xlDetialsPage.vue?vue&type=script&lang=js"
export * from "./xlDetialsPage.vue?vue&type=script&lang=js"
import style0 from "./xlDetialsPage.vue?vue&type=style&index=0&id=77cff94a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cff94a",
  null
  
)

export default component.exports